<template>
  <div class="main">
    <div class="title-bar">
      <div class="row">
        <div class="col-12 col-md-6 mb-3 mb-md-0 text-center text-md-left">
          <h1>Classroom Enrollment</h1>
        </div>
        <div class="col-12 col-md-6 mb-4 mb-md-0 text-center text-md-right">
          <a class="btn btn-success" href="#" @click.prevent="addWriteIn()"
            >Add Write-In</a
          >
        </div>
      </div>
    </div>
    <div class="content p-4">
      <transition name="fade">
        <Alert v-if="hasAlert" :alert="alert" />
      </transition>
      <div class="row">
        <div class="col-12 col-xl-8 mb-5 mb-xl-0">
          <UserSearchForm
            enrollable-type="Event"
            :enrollable-id="event.id"
            :coworkers="coworkers"
            @add-to-queue="addToQueue"
            @add-write-in="addWriteIn"
          />
          <hr />
          <FormWrapper
            :action="formAction"
            method="POST"
            @submit="formSubmitted"
          >
            <h3 class="mb-4">Pending Enrollments</h3>
            <UserSearchQueue
              enrollable-type="Event"
              :enrollable-id="event.id"
              :queue="pending"
              @edit-write-in="editWriteIn"
              @remove-from-queue="removeFromQueue"
            />
            <div class="mt-4 text-center text-xl-left">
              <button
                type="submit"
                class="btn btn-success mb-3 w-50 mb-sm-0 mr-sm-1 w-sm-auto"
                :class="{
                  disabled: pending.length === 0 || submitted === true,
                }"
              >
                Add to Roster
              </button>
              <a :href="cancelUrl" class="btn btn-danger w-50 ml-sm-1 w-sm-auto"
                >Cancel &amp; Exit</a
              >
            </div>
          </FormWrapper>
        </div>
        <div class="col-12 col-xl-4">
          <DetailsPane
            :title="event.name"
            :hide-close="true"
            :auto-height="true"
          >
            <div class="p-4">
              <EventOverview :event="event" class="details-pane-table" />
              <div class="mt-4 text-center">
                <a
                  class="btn btn-primary"
                  :href="route('catalog.course', { course: event.course_id })"
                  >View Course</a
                >
              </div>
            </div>
          </DetailsPane>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserSearchForm from "../partials/UserSearchForm";
import UserSearchQueue from "../partials/UserSearchQueue";
import DetailsPane from "components/listings/DetailsPane";
import EventOverview from "components/partials/Events/EventOverview";
import DisplaysAlerts from "mixins/DisplaysAlerts";
import WriteInModal from "./partials/WriteIn";

export default {
  mixins: [DisplaysAlerts],

  components: {
    UserSearchForm,
    UserSearchQueue,
    DetailsPane,
    EventOverview,
  },

  props: {
    event: { type: Object, required: true },
    coworkers: { type: Array, default: () => [] },
    queue: { type: Object, required: true },
    referer: { type: String, default: null },
    enrollments: { type: Array, default: () => [] }
  },

  data() {
    return {
      pending: [],
      submitted: false,
    };
  },

  computed: {
    formAction() {
      return this.route("enroll.classroom.event.queue.save", {
        event: this.event.id,
      });
    },
    cancelUrl() {
      if (document.referrer) {
        return document.referrer
      }
      if (this.$root.isAdmin) {
        return this.route("admin.events.enrollments.index", { event: this.event.id });
      } else {
        return this.route("catalog.classroom");
      }
    },
  },

  methods: {
    addMyselfToQueue() {
      var user = _.cloneDeep(this.$root.user);
      user.selectedBrand = _.cloneDeep(user.defaultBrand);
      this.addToQueue(user);
    },
    addToQueue(user) {
      if (this.isInQueue(user)) {
        alert(`You have already added ${user.name} to the pending queue.`);
        return;
      }

	  if (this.pending.length >= this.allowedInQueue() && !this.$root.isSuperUser) {
		  alert(`There are no more seats available for this event`);
		  return;
	  }

      this.pending.push(user);
      window.scrollTo(0,document.body.scrollHeight);
    },
    removeFromQueue(user) {
      var queue = this.pending;
      this.pending = [];
      this.pending = queue.filter((item) => item.id !== user.id);
    },
    isInQueue(user) {
      return !!this.pending.find((item) => item.id === user.id);
    },
    addWriteIn() {
      var opts = { event: this.event };
      this.$modal(WriteInModal, opts)
        .then((user) => {
          this.addToQueue(user);
          this.addWriteIn();
        })
        .catch();
    },
    editWriteIn(user) {
      var opts = { event: this.event, user: user };
      this.$modal(WriteInModal, opts)
        .then((user) => {
          this.removeFromQueue(user);
          this.addToQueue(user);
        })
        .catch();
    },
	  allowedInQueue() {
		if (!this.event.max_attendees) {
			return 9999;
		}
		return this.event.max_attendees - this.enrollments.length;
	  },
    formSubmitted() {
      this.submitted = true;
      this.$root.showLoading("Adding users to queue. Please wait...");
    },
  }
};
</script>